import 'globals';

(function($, window, document, pageLoadedQueue) {
    pageLoadedQueue.push(function() {
        // Overwrite translation from `Back` to the language of the Site
        var backButton = $('.offcanvas-menu .offcanvas-submenu .back-btn a');
        var backBtnText = _AVENCY_BASE_translations.nightstar.mobileMenu.back;
        backButton.text(backBtnText);

        document.querySelector('.search-click-container').addEventListener('click', function() {
            document.querySelector('.search-input-container').classList.toggle('d-none');
        });
    });
})(jQuery, window, document, window.pageLoadedQueue);
